<div class="form-title">
  <div class="form-title-text">Extra's</div>
</div>

<ng-container *ngFor="let product of project.products; let i = index">
  <ng-container *ngIf="product.type === 'IPBoard'">
    <ip-board-height
      [ipBoard]="product"
      [multiple]="multipleIPBoards"
      [index]="i"
      (update)="update.emit()"
    ></ip-board-height>

    <ip-board-arrows
      [ipBoard]="product"
      [multiple]="multipleIPBoards"
      [index]="i"
      [client]="client"
      (update)="update.emit()"
    ></ip-board-arrows>
  </ng-container>
</ng-container>

<ip-board-second-board
  [project]="project"
  [projectPlacement]="projectPlacement"
  (update)="update.emit()"
></ip-board-second-board>

<div>
  <mat-checkbox
    [(ngModel)]="withOtherOrder"
    (ngModelChange)="withOtherOrderChanged()"
    >Andere bestelling</mat-checkbox
  >

  <ng-container *ngIf="withOtherOrder">
    <mat-card class="top-card mat-elevation-z0 secondary-border-color">
      <textarea-input
        [title]="'Info omtrent de plaatsing van deze bestelling'"
        [initContent]="projectPlacement.otherOrderPlacementInfo"
        [placeholder]="''"
        [client]="client"
        [sensitive]="true"
        (answer)="otherOrderPlacementInfoChanged($event)"
      ></textarea-input>
    </mat-card>

    <p>Prijs en ontwerp zullen eerst opgemaakt worden</p>
  </ng-container>
</div>
